module.exports = __webpack_public_path__ + "static/img/MM.176f494f.svg";